const translations = {
  en: {
    expressDeposit: 'EXPRESS DEPOSIT',
    expressDisabledTitle: 'You need to deposit first to have this option available',
    withdrawalOptions: 'WITHDRAWAL OPTIONS',
    errorGettingLimits: 'Error getting deposit limits info: ',
    error: 'Error',
    min: 'Min',
    max: 'Max',
    noLimit: 'No Limit',
  },
  es: {
    expressDeposit: 'DEPÓSITO EXPRESS',
    expressDisabledTitle: 'Necesita depositar primero para tener esta opción disponible',
    withdrawalOptions: 'OPCIONES DE RETIRO',
    errorGettingLimits: 'Error obteniendo información de límites del depósito: ',
    error: 'Error',
    min: 'Mín',
    max: 'Máx',
    noLimit: 'Sin Límite',
  },
  pt: {
    expressDeposit: 'DEPÓSITO EXPRESS',
    expressDisabledTitle: 'Você precisa depositar primeiro para ter esta opção disponível',
    withdrawalOptions: 'OPÇÕES DE SAQUE',
    errorGettingLimits: 'Erro ao obter informações dos limites de depósito: ',
    error: 'Erro',
    min: 'Mín',
    max: 'Máx',
    noLimit: 'Sem Limite',
  },
}

export default translations
